import type { NavLinkProps } from 'react-router';

import { NavLink } from 'react-router';

import { clsxs } from '~/styles/utils';

import type { IconName } from '../Icon/Icon';

import { Icon } from '../Icon/Icon';
import { useNavigationContext } from './Navigation.context';
import { itemActiveStyle, itemStyle } from './Navigation.css';
import { NavigationTooltip } from './NavigationTooltip';

export type NavigationLinkProps = NavLinkProps & {
  active?: boolean;
  children: string;
  icon: IconName;
};

export const NavigationLink = ({ active, children, end = false, icon, ...delegated }: NavigationLinkProps) => {
  const { showLabels } = useNavigationContext();

  return (
    <NavigationTooltip tooltip={children}>
      <NavLink {...delegated} aria-label={children} className={clsxs(itemStyle, active && itemActiveStyle, delegated.className)} end={end}>
        <Icon name={icon} />

        {showLabels && <span>{children}</span>}
      </NavLink>
    </NavigationTooltip>
  );
};
